import React from 'react'
import { Link } from 'react-router-dom'
import './integrations-nav.css'

const IntegrationsNav = ({ className = '' }) => (
  <Link to="/integrations" className={`integrations-trigger ${className}`}>
    Integrations
  </Link>
)

export default IntegrationsNav
